import type { ListNotificationsResponse, MarkAllNotificationsReadResponse } from '@brainkey/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { UseMutationResult, UseQueryResult } from '@tanstack/react-query';

import { toast } from '../../components/ui/Toast';
import { notificationsApi } from '../api/endpoints';
import { queryKeys } from '../queryClient';

export function useNotifications(): UseQueryResult<ListNotificationsResponse> {
  return useQuery({
    queryKey: queryKeys.notifications.all,
    queryFn: ({ signal }) => notificationsApi.list(signal),
    refetchInterval: 30_000,
  });
}

export function useMarkNotificationRead(): UseMutationResult<
  Awaited<ReturnType<typeof notificationsApi.markRead>>,
  unknown,
  string
> {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => notificationsApi.markRead(id),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.notifications.all });
    },
  });
}

export function useMarkAllNotificationsRead(): UseMutationResult<
  MarkAllNotificationsReadResponse,
  unknown,
  void
> {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => notificationsApi.markAllRead(),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: queryKeys.notifications.all });
      toast.success('All notifications marked as read');
    },
  });
}
